<template>
  <ApiSimpleSearch
      :url=         "url"
      :cardsMap=    "cardsMap"
      :requestObj=  "requestObj"
  >
    <v-col cols="12">
      <v-select
          outlined
          reverse
          dense
          :items=     "selectItems"
          :label=     "$t('field.selectBookCategory')"
          v-model=    "selected"
          :loading=   "!ready || requestObj.loading"
          :disabled=  "!ready || requestObj.loading"
          @change=    "requestObj.makeRequest"
      ></v-select>
    </v-col>
  </ApiSimpleSearch>
</template>

<script>
  import ApiSimpleSearch from '../components/ApiSimpleSearch'

  export default {
    name:       'Claims',
    components: { ApiSimpleSearch },
    data: function() {
      return {
        ready:        false,
        selected:     null,
        selectItems:  [],
        requestObj: {
          makeRequest: () => {
            // this method will be replaced by the simple search component
          },
          loading: false
        },
        cardsMap: [
          { name: 'basicInfo', fields: 'TITLE,SUBTITLE,BOOKNUM'.split(',') }
        ]
      }
    },
    methods: {
      url() {
        return `/apiv1/books?BOOKNUM=${this.selected}`
      },
      validate(value) {
        return !!(value || '').trim()
      },
      setSelectItems() {
        this.selectItems = this.$store.state.booksCategories[this.$route.meta.cat] || []
        this.ready = true
      }
    },
    watch:{
      "$route.path": {
        handler: function() {
          this.setSelectItems()
        },
        immediate: true
      },
      "$store.state.booksCategories": {
        handler: function(booksCategories) {
          if (Object.keys(booksCategories).length > 0){
            this.setSelectItems()
          }
        },
        deep: true
      }
    }
  }
</script>
